"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateOfferItemsEvent = exports.Name = void 0;
const Name = exports.Name = 'update-offer-items';
const UpdateOfferItemsEvent = exports.UpdateOfferItemsEvent = Name;
//# sourceMappingURL=index.js.map